(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mos-home-faq-i18n"] && !Shopify.designMode) return;
  try {
    
const initMosHomeFaq = () => {
  document.querySelectorAll('.mos-home-faq').forEach((section) => {
    if (section.dataset.mosFaqReady === 'true') {
      return;
    }

    section.dataset.mosFaqReady = 'true';
    section.querySelectorAll('.mos-home-faq__item').forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) {
          return;
        }

        section.querySelectorAll('.mos-home-faq__item[open]').forEach((openItem) => {
          if (openItem !== item) {
            openItem.removeAttribute('open');
          }
        });
      });
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMosHomeFaq, { once: true });
} else {
  initMosHomeFaq();
}

document.addEventListener('shopify:section:load', initMosHomeFaq);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mos-home-reviews-i18n"] && !Shopify.designMode) return;
  try {
    
const initMosReviewSliders = () => {
  document.querySelectorAll('.mos-home-reviews').forEach((root) => {
    if (root.dataset.mosReviewSlider === 'true') {
      return;
    }

    const source = root.querySelector('.mos-home-reviews__carousel');
    const slider = root.querySelector('.mos-review-slider');
    const track = slider?.querySelector('.mos-review-slider__track');
    const previous = slider?.querySelector('[data-review-previous]');
    const next = slider?.querySelector('[data-review-next]');
    const status = slider?.querySelector('.mos-review-slider__status');
    const playback = slider?.querySelector('[data-review-playback]');
    const originalSlides = source ? Array.from(source.querySelectorAll('.jdgm-carousel-item')) : [];

    if (!source || !slider || !track || !previous || !next || !status || !playback || originalSlides.length === 0) {
      return;
    }

    originalSlides.forEach((original) => {
      const slide = document.createElement('article');
      const review = original.querySelector('.jdgm-carousel-item__review');
      const reviewer = original.querySelector('.jdgm-carousel-item__reviewer-name-wrapper');
      slide.className = 'mos-review-slider__slide';

      if (review) {
        slide.append(review.cloneNode(true));
      }

      if (reviewer) {
        const reviewerClone = reviewer.cloneNode(true);
        reviewerClone.querySelectorAll('.jdgm-carousel-item__reviewer-name').forEach((name) => {
          name.style.setProperty('color', '#514c46', 'important');
        });
        slide.append(reviewerClone);
      }

      track.append(slide);
    });

    const slides = Array.from(track.querySelectorAll('.mos-review-slider__slide'));
    const desktop = window.matchMedia('(min-width: 750px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const abort = new AbortController();
    const listen = (target, name, handler) => target.addEventListener(name, handler, { signal: abort.signal });
    let index = 0;
    let timer;
    let paused = reducedMotion.matches;
    let hovered = false;
    let focused = false;
    let inView = false;
    let gesture = null;

    const maximumIndex = () => Math.max(0, slides.length - (desktop.matches ? 3 : 1));
    const schedule = () => {
      clearTimeout(timer);
      if (!paused && !hovered && !focused && inView && !document.hidden && !gesture && maximumIndex() > 0) {
        timer = setTimeout(() => { move(1); }, 6000);
      }
    };
    const update = () => {
      const visibleCount = desktop.matches ? Math.min(3, slides.length) : 1;
      index = Math.min(index, maximumIndex());
      slides.forEach((slide, slideIndex) => {
        slide.hidden = slideIndex < index || slideIndex >= index + visibleCount;
      });
      previous.disabled = next.disabled = maximumIndex() === 0;
      playback.disabled = maximumIndex() === 0;
      playback.setAttribute('aria-pressed', String(paused));
      playback.setAttribute('aria-label', paused ? playback.dataset.playLabel : playback.dataset.pauseLabel);
      playback.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
      status.textContent = (index + 1) + '–' + Math.min(index + visibleCount, slides.length) + ' / ' + slides.length;
      schedule();
    };
    const move = (direction) => {
      const count = maximumIndex() + 1;
      index = (index + direction + count) % count;
      update();
    };
    listen(previous, 'click', () => move(-1));
    listen(next, 'click', () => move(1));
    listen(playback, 'click', () => { paused = !paused; update(); });
    listen(slider, 'pointerenter', (event) => {
      if (event.pointerType === 'mouse') { hovered = true; schedule(); }
    });
    listen(slider, 'pointerleave', (event) => {
      if (event.pointerType === 'mouse') { hovered = false; schedule(); }
    });
    listen(slider, 'focusin', () => { focused = true; schedule(); });
    listen(slider, 'focusout', (event) => {
      focused = slider.contains(event.relatedTarget);
      schedule();
    });
    listen(track, 'pointerdown', (event) => {
      if (!event.isPrimary || event.button !== 0 || event.target.closest('a, button')) return;
      gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
      if (event.pointerType === 'mouse') track.setPointerCapture(event.pointerId);
      schedule();
    });
    listen(track, 'pointerup', (event) => {
      if (!gesture || gesture.id !== event.pointerId) return;
      const dx = event.clientX - gesture.x;
      const dy = event.clientY - gesture.y;
      gesture = null;
      if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.3) {
        const rtl = getComputedStyle(track).direction === 'rtl';
        move((dx < 0 ? 1 : -1) * (rtl ? -1 : 1));
      } else schedule();
    });
    listen(track, 'pointercancel', () => { gesture = null; schedule(); });
    listen(track, 'dragstart', (event) => event.preventDefault());
    listen(document, 'visibilitychange', schedule);
    listen(desktop, 'change', update);
    listen(reducedMotion, 'change', () => { paused = reducedMotion.matches; update(); });
    const observer = new IntersectionObserver((entries) => {
      inView = entries[0].isIntersecting;
      schedule();
    }, { threshold: 0.25 });
    observer.observe(track);
    listen(document, 'shopify:section:unload', (event) => {
      if (event.target.contains(root)) {
        clearTimeout(timer);
        observer.disconnect();
        abort.abort();
      }
    });
    root.dataset.mosReviewSlider = 'true';
    source.hidden = true;
    slider.hidden = false;
    update();
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMosReviewSliders, { once: true });
} else {
  initMosReviewSliders();
}

document.addEventListener('shopify:section:load', initMosReviewSliders);

  } catch(e) { console.error(e); }
})();
})();
